"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TraditionalvRothRefineModal;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _TraditionalvRothModalFormControls = require("./TraditionalvRothModalFormControls");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function TraditionalvRothRefineModal(props) {
  var {
    handleClose,
    snapshot,
    show,
    fetchDataScienceResults
  } = props;

  // Pulling formik context from higher up, which gives us access to formik state
  var {
    values: {
      employerMatchYN
    },
    errors,
    touched,
    setFieldValue,
    values,
    isSubmitting,
    isValid
  } = (0, _formik.useFormikContext)();
  var handleSubmit = e => {
    e.preventDefault();
    handleClose();
    fetchDataScienceResults(values, {
      setFieldValue: setFieldValue
    });
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "lg",
    show: show
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(snapshot),
    title: "Edit your inputs & our assumptions"
  }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-6 col-sm-12"
  }, /*#__PURE__*/_react.default.createElement("h3", null, "Your Details"), /*#__PURE__*/_react.default.createElement(_TraditionalvRothModalFormControls.CurrentAge, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_TraditionalvRothModalFormControls.State, {
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_TraditionalvRothModalFormControls.Salary, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_TraditionalvRothModalFormControls.TaxRate, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_TraditionalvRothModalFormControls.FilingStatus, {
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_TraditionalvRothModalFormControls.TaxPreference, {
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement("h3", null, "Assumed Rates"), /*#__PURE__*/_react.default.createElement(_TraditionalvRothModalFormControls.AnnualRaise, {
    values: values,
    errors: errors,
    touched: touched,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_TraditionalvRothModalFormControls.RateOfReturn, {
    values: values,
    errors: errors,
    touched: touched,
    setFieldValue: setFieldValue
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-6 col-sm-12"
  }, /*#__PURE__*/_react.default.createElement("h3", null, "Retirement Plan Contributions"), /*#__PURE__*/_react.default.createElement(_TraditionalvRothModalFormControls.PlanType, {
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_TraditionalvRothModalFormControls.CurrentContribution, {
    values: values,
    errors: errors,
    touched: touched,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_TraditionalvRothModalFormControls.EmployerMatchYN, {
    values: values,
    setFieldValue: setFieldValue
  }), employerMatchYN === "doesn't match" ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_TraditionalvRothModalFormControls.EmployerMatchRate, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_TraditionalvRothModalFormControls.EmployerMatchLimit, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  })), /*#__PURE__*/_react.default.createElement("h3", null, "Your Retirement"), /*#__PURE__*/_react.default.createElement(_TraditionalvRothModalFormControls.RetirementAge, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_TraditionalvRothModalFormControls.WithdrawalAge, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_TraditionalvRothModalFormControls.RetTaxRate, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }))))), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Footer, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    variant: "link",
    onClick: () => handleClose(snapshot)
  }, "Cancel"), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    disabled: isSubmitting || !isValid,
    onClick: handleSubmit
  }, "Update"))));
}